import buildUrl from './buildUrl.mjs'

export default (path, params = {}, target, features) => {
    const url = buildUrl(path, params)
    return window.open(url, target, features)
}
